import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/authaxios";

const initialState = { status: null, data: [], loading: false, message: '' };



export const createCategoryAction = createAsyncThunk("create-category", async (data, { rejectWithValue }) => {
    try {

        const response = await axios.post(`/admin/product/category`, { ...data });
        console.log("response-->", response.data)
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data)
    }
});

const createCategorySlice = createSlice({
    name: "create-category",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(createCategoryAction.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createCategoryAction.fulfilled, (state, action) => {
            state.loading = false;
            state.message = action.payload?.message;
            state.status = action.payload.status_code;
            if(state.status==401){
                localStorage.clear()
              }
            state.data = action.payload?.response;
        });
        builder.addCase(createCategoryAction.rejected, (state, action) => {
            state.loading = false;
            state.message = action.payload?.message;
            state.status = action.payload.status_code;
            state.error = action.error.message;
        });
    },
});




export const createCategoryReducer = createCategorySlice.reducer;

